<div class="m-0 p-0" >
  @if (userId !== undefined && userId !== null) {
    <app-detailsforpage
      [postKey]="postKey"
      [organizationKey]="organizationKey"
      [projectKey]="projectKey"
      [isNewPost]="false"
      [userId]="userId"
      [type]="type"
      [post]="post"
      [fields]="post.fields"
      [projectName]="projectName"
      [isReadOnly]="isReadOnly"
      [launchedAsSubcomponent]="false"
      [columnKey]="columnKey"
      [color]="color"
      [areKidsColored]="areKidsColored"
      [areKidsTagged]="areKidsTagged"
      [isCompleted]="isCompleted"
      [isDeleted]="isDeleted"
      [imageURLs]="imageURLs"
      [isFavourite]="isFavourite"
      [isReadOnly]="isReadOnly"
      [isRead]="isRead"
      [isTop]="isTop"
      [templateKey]="templateKey"
      [userName]="userDisplayName"
      [embeddingModel]="embeddingModel"
      [captureImage]="captureImage"
      [globalTags]="globalTags"
      [selectedTeamKey]="selectedTeamKey"
      (closePopup)="close($event)"
      (sendStatusUpdate)="updateStatus($event)"
      (sendColorUpdate)="updateColor($event)"
      (sendNameUpdate)="updateName($event)"
      (sendIsComplete)="updateComplete($event)"
      (sendDelete)="updateDelete($event)"
      (sendCoverImageUpdate)="updateCoverImage($event)"
    ></app-detailsforpage>
  }
</div>